import script from "./Stepper.vue?vue&type=script&setup=true&lang=ts"
export * from "./Stepper.vue?vue&type=script&setup=true&lang=ts"

import "./Stepper.vue?vue&type=style&index=0&id=2b0b2a14&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b0b2a14"]])

export default __exports__